<template>
  <div class="wrapper" v-loading="isLoading">
    <navbar v-if="!demoGuest" :inverted="false"></navbar>
    <div :class="`app-middle ${demoGuest ? 'demo-guest' : ''}`">
      <overhead-desktop />
      <router-view />
    </div>
    <modal-window />
  </div>
</template>

<script>
import Navbar from "@/components/navbar/navbar";
import OverheadDesktop from "@/components/overhead-desktop/overhead-desktop";
import ModalWindow from "@/components/modal-window/modal-window";
import { notifyFactory } from "@/utils";

export default {
  components: {
    Navbar,
    OverheadDesktop,
    ModalWindow
  },
  data() {
    return {
      isLoading: false,
      demoGuest: this.$store.state.demoGuest
    };
  },
  watch: {
    "$store.state.profiles.profileUpdated": {
      handler: function(val) {
        this.isLoading = val;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    closeHandler() {
      this.$socket.emit("leaved", this.$store.state.auth.user.user);

      if (this.$store.state.demoGuest) return;

      this.$store.dispatch("SAVE_MAIN_USER_CONFIG", "unload");
    },
    startSessionWithToken() {
      this.createSocketConnection();
    },
    createSocketConnection() {
      const { token } = this.$store.state.auth;
      this.$socket.io.opts.query = { token };
      this.$socket.open();
      // data import tasks socket updating
      this.$socket.on("data_import", data => {
        const { task_id, status } = data;
        const title =
          status === "OK" ? "Задача выполнена" : "Задача не выполнена";
        const message =
          status === "OK"
            ? `Задача ${task_id} выполнена успешно`
            : `Задача ${task_id} не выполнена. Повторите попытку`;
        const type = status === "OK" ? "success" : "error";
        this.$notify(notifyFactory(type, title, message));
        this.$store.commit("REMOVE_ACTIVE_TASK", task_id);
        if (status === "OK") {
          this.$store.commit("PROFILE_TREE_UPDATED", {
            action: "toggle",
            value: true
          });
          this.$store.commit("SET_UPDATE_DS_TREE", true);
        }
      });
      // worker tasks socket updating
      this.$socket.on("worker", data => {
        const { task_id, status, type } = data;
        let title;
        let message;

        switch (type) {
          case "OsrmProcess":
            title =
              status === "OK"
                ? "Маршрутизатор обновлен"
                : "Машрутизатор не обновлен";
            message =
              status === "OK"
                ? `Задача по обновлению маршрутизатора ${task_id} выполнена успешно`
                : `Задача по обновлению маршрутизатора ${task_id} не выполнена. Повторите попытку`;
            break;
        }

        const notifyType = status === "OK" ? "success" : "error";
        this.$notify(notifyFactory(notifyType, title, message));
        this.$store.commit("REMOVE_ACTIVE_TASK", task_id);
        if (status === "OK") {
          this.$store.commit("PROFILE_TREE_UPDATED", {
            action: "toggle",
            value: true
          });
          this.$store.commit("SET_UPDATE_DS_TREE", true);
        }
      });
      this.$socket.on("auth.permission_objects", ({ data, action }) => {
        console.log("SOCKET UPDATE DATA --- ", data, action);
        switch (action) {
          case "create":
            this.$store.commit("ADD_DATASOURCES", data);
            break;
          case "delete":
            this.$store.commit("DELETE_DATASOURCES", { ids: data });
            break;
          case "update":
            this.$store.commit("UPDATE_DATASOURCES", data);
        }
      });

      this.$socket.on("loadMessages", messages => {
        this.$store.commit("SET_MESSAGE_LIST", messages);
      });
    },
    async loadSettings() {
      try {
        const { data } = await this.$store.dispatch("REQUEST", {
          url: "settings"
        });

        this.$store.commit("SET_SETTINGS", data);
      } catch (e) {
        console.log(e);
      }
    }
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    isAuthorised() {
      return !!this.$store.state.auth.token;
    }
  },
  created() {
    const { token } = this.$store.state.auth;
    this.loadSettings();

    window.addEventListener("beforeunload", this.closeHandler);
    if (token) {
      this.startSessionWithToken(token);
    } else {
      this.$store.commit("CLEAR_USER_DATA");
    }
    this.$root.$i18n.locale = this.$store.state.locale || "ru";

    if (this.$store.state.demoGuest) {
      return this.$router.push({ path: "/app/map" });
    }

    if (this.$router.currentRoute.path !== this.$store.state.defaultPath)
      this.$router.push({ path: this.$store.state.defaultPath });
  }
};
</script>

<style></style>
